import { useState } from 'react';

const TIME_OPTIONS = Array.from({ length: 24 }, (_, h) =>
  Array.from({ length: 60 }, (_, m) => `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`)
).flat();

export default function DateTimePicker({ value, onChange, includeTime = true }) {
  const [showTime, setShowTime] = useState(false);

  const dateValue = value ? (typeof value === 'string' ? value.split('T')[0] : new Date(value).toISOString().split('T')[0]) : '';
  const timeValue = value ? (typeof value === 'string' && value.includes('T') ? value.split('T')[1].slice(0, 5) : '') : '';

  const handleDateChange = (e) => {
    const newDate = e.target.value;
    const currentTime = timeValue || '00:00';
    onChange(`${newDate}T${currentTime}`);
  };

  const handleTimeChange = (e) => {
    const newTime = e.target.value;
    const currentDate = dateValue || new Date().toISOString().split('T')[0];
    onChange(`${currentDate}T${newTime}`);
  };

  return (
    <div className="flex gap-2">
      <input type="date" value={dateValue} onChange={handleDateChange} className="input text-sm" />
      {includeTime && (
        <>
          <input type="time" value={timeValue} onChange={handleTimeChange} className="input text-sm w-24" />
        </>
      )}
    </div>
  );
}

export function TimeSelect({ value, onChange, label }) {
  const hours = Array.from({ length: 24 }, (_, h) => h.toString().padStart(2, '0'));
  const minutes = Array.from({ length: 60 }, (_, m) => m.toString().padStart(2, '0'));

  return (
    <div className="flex items-center gap-2">
      {label && <span className="text-sm text-dark-400">{label}</span>}
      <select value={value ? value.split(':')[0] : ''} onChange={(e) => {
        const h = e.target.value;
        const m = value ? value.split(':')[1] : '00';
        onChange(`${h}:${m}`);
      }} className="input text-sm w-16">
        {hours.map((h) => <option key={h} value={h}>{h}</option>)}
      </select>
      <span className="text-dark-500">:</span>
      <select value={value ? value.split(':')[1] : ''} onChange={(e) => {
        const h = value ? value.split(':')[0] : '00';
        const m = e.target.value;
        onChange(`${h}:${m}`);
      }} className="input text-sm w-16">
        {minutes.map((m) => <option key={m} value={m}>{m}</option>)}
      </select>
    </div>
  );
}
